/* eslint-disable import/no-named-as-default */
import React from "react";
import PropTypes from "prop-types";
import Step1 from "./RatingSteps/Step1";
import Step2 from "./RatingSteps/Step2";
import Step3 from "./RatingSteps/Step3";
import Step4 from "./RatingSteps/Step4";
import Message from "./RatingSteps/Message";

const RatingSteps = ({
  setRating,
  reviewStep,
  step1Rating,
  step2Rating,
  step3Rating,
  step4Rating,
  setReviewMessage,
  reviewMessage,
}) => {
  let currentStep;

  switch (reviewStep) {
    case 2:
      currentStep = <Step2 setRating={setRating} rating={step2Rating} />;
      break;
    case 3:
      currentStep = <Step3 setRating={setRating} rating={step3Rating} />;
      break;
    case 4:
      currentStep = <Step4 setRating={setRating} rating={step4Rating} />;
      break;
    case 5:
      currentStep = (
        <Message
          setReviewMessage={setReviewMessage}
          reviewMessage={reviewMessage}
        />
      );
      break;
    default:
      currentStep = <Step1 setRating={setRating} rating={step1Rating} />;
      break;
  }
  return currentStep;
};

RatingSteps.propTypes = {
  setRating: PropTypes.func.isRequired,
  reviewStep: PropTypes.number.isRequired,
  step1Rating: PropTypes.number,
  step2Rating: PropTypes.number,
  step3Rating: PropTypes.number,
  step4Rating: PropTypes.number,
  setReviewMessage: PropTypes.func.isRequired,
  reviewMessage: PropTypes.string.isRequired,
};

RatingSteps.defaultProps = {
  step1Rating: PropTypes.isNull,
  step2Rating: PropTypes.isNull,
  step3Rating: PropTypes.isNull,
  step4Rating: PropTypes.isNull,
};

export default RatingSteps;
